import React from "react";
import { useSelector } from "react-redux";
import userActions from "../actions";
import ReuseConfirmationDialog from "components/common/ReuseConfirmationDialog";

const DeactivateConfirmation = () => {
  const { isConfirmationDialogOpen } = useSelector((state) => state.settings);
  const { openDeactivateConfirmationDialog, deactivateSelf } = userActions();

  const handleClose = () => {
    openDeactivateConfirmationDialog(false);
  };

  return (
    <ReuseConfirmationDialog
      open={isConfirmationDialogOpen}
      handleConfirm={() => {
        deactivateSelf();
        openDeactivateConfirmationDialog(false);
      }}
      handleCancel={handleClose}
      dialogData={{
        title: "Deactivate Confirmation",
        desc: "Are you sure you want to deactivate from the system?",
      }}
    />
  );
};

export default DeactivateConfirmation;
